module.exports = __webpack_public_path__ + "static/img/CODY-CURTIN.3cf7919.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CODY-CURTIN.jpg
// module id = 1BQj
// module chunks = 0